import { Injectable } from '@angular/core';
import Bugsnag from '@bugsnag/js';
import { BugsnagErrorHandler } from '@bugsnag/plugin-angular';
import { environment } from '@meplis/environments';
import { ChunkErrorHandler } from './chunk-error-handler';

@Injectable()
export class AppErrorHandler extends ChunkErrorHandler {
  private readonly _bugsnagHandler = new BugsnagErrorHandler();

  override handleError(error: unknown): void {
    const normalizedError = this._normalizeError(error);

    if (environment.production && Bugsnag.isStarted()) {
      try {
        // BugsnagErrorHandler unwraps Angular-wrapped errors and reports them.
        // It re-throws internally, so we swallow that re-throw here.
        this._bugsnagHandler.handleError(normalizedError);
      } catch {
        // intentional: let ChunkErrorHandler below handle the final console.error / reload
      }
    }
    super.handleError(error);
  }

  private _normalizeError(error: unknown): Error {
    if (error instanceof Error) {
      return error;
    }

    if (typeof error === 'string') {
      return new Error(error);
    }

    if (error === undefined) {
      return new Error('Unknown error (undefined)');
    }

    if (error === null) {
      return new Error('Unknown error (null)');
    }

    try {
      return new Error(JSON.stringify(error));
    } catch {
      return new Error(String(error));
    }
  }
}
